import ModalController from './modal_controller';

export default class extends ModalController {
  static targets = ["container", "entry", "destroyField"]

  show(event) {
    super.show(event);

    this.stimulate(
      (event.target.dataset.showReflexClass || 'CompanyReflex') + '#show_company_modal',
      event.currentTarget,
    );
  }

submitCompany(event) {
  event.preventDefault();

  var target = event.currentTarget;
  var originalLabel = target.innerHTML;
  if (target.disabled === true) { return }
  target.disabled = true;
  target.innerHTML = event.currentTarget.dataset.stimulusDisableWith;

  this.stimulate(
    (event.target.dataset.submitReflexClass || 'CompanyReflex') + '#' + (event.target.dataset.submitReflexAction || 'submit_company_modal'), event.target)
    .then(payload => {
      const html = payload.event.detail.html;
      const hasDuplicateConfirmation = html && html.includes('alert-warning');

      if (!hasDuplicateConfirmation) {
        // Pouze pokud NENÍ duplicate confirmation, zavřeme modal
        this.closeModal();
        const success_event = new CustomEvent('save-indicator:success', { detail: payload });
        window.dispatchEvent(success_event);

        if (html) {
          let parser = new DOMParser();
          let element = parser.parseFromString(html, 'text/html');
          let redirectLink = element.querySelector('a#redirect_to');
          if (redirectLink != undefined) {
            window.location.replace(redirectLink.getAttribute('href'))
          }
        }
      }
    })
    .catch(payload => {
      const failed_event = new CustomEvent('save-indicator:failed', { detail: payload });
      let title = payload.element.closest('.modal-dialog').querySelector('.header h4');
      title.innerHTML = payload.event.detail.stimulusReflex.serverMessage.body;
      title.classList.toggle('error')
      window.dispatchEvent(failed_event);
    })
    .finally(() => {
      target.disabled = false;
      target.innerHTML = originalLabel;
    });
}

  addPhone(event) {
    event.preventDefault();
    const newEntry = this.createPhoneEntry();
    this.containerTarget.insertAdjacentHTML('beforeend', newEntry);
  }

  removePhone(event) {
    event.preventDefault();

    const entry = event.target.closest('[data-target="company-modal.entry"]');
    const destroyField = entry.querySelector('[data-target="company-modal.destroyField"]');

    if (destroyField) {
      destroyField.value = "1";
      entry.classList.add('marked-for-deletion');
      entry.style.opacity = '0.5';
      entry.style.textDecoration = 'line-through';

      const removeLink = event.target;
      removeLink.textContent = '↺';
      removeLink.dataset.action = 'click->company-modal#undoRemove';
    } else {
      entry.remove();
    }
  }

  undoRemove(event) {
    event.preventDefault();

    const entry = event.target.closest('[data-target="company-modal.entry"]');
    const destroyField = entry.querySelector('[data-target="company-modal.destroyField"]');

    if (destroyField) {
      destroyField.value = "0";
      entry.classList.remove('marked-for-deletion');
      entry.style.opacity = '1';
      entry.style.textDecoration = 'none';

      const removeLink = event.target;
      removeLink.textContent = '×';
      removeLink.dataset.action = 'click->company-modal#removePhone';
    }
  }

  createPhoneEntry() {
    const timestamp = new Date().getTime();

    return `
      <div class="phone-entry" data-target="company-modal.entry">
        <div class="phone-fields-row">
          <div class="phone-number-field">
            <label for="installations_company_company_attributes_phones_attributes_${timestamp}_number">${this.getLabel('number')}</label>
            <input type="text" name="installations_company[company_attributes][phones_attributes][${timestamp}][number]" id="installations_company_company_attributes_phones_attributes_${timestamp}_number" />
          </div>

          <div class="phone-type-field">
            <label for="installations_company_company_attributes_phones_attributes_${timestamp}_phone_type">${this.getLabel('phone_type')}</label>
            <select name="installations_company[company_attributes][phones_attributes][${timestamp}][phone_type]" id="installations_company_company_attributes_phones_attributes_${timestamp}_phone_type">
              ${this.getPhoneTypeOptions()}
            </select>
          </div>

          <div class="phone-use-case-field">
            <label for="installations_company_company_attributes_phones_attributes_${timestamp}_use_case">${this.getLabel('use_case')}</label>
            <select name="installations_company[company_attributes][phones_attributes][${timestamp}][use_case]" id="installations_company_company_attributes_phones_attributes_${timestamp}_use_case">
              ${this.getUseCaseOptions()}
            </select>
          </div>

          <a href="#" class="remove-phone" data-action="click->company-modal#removePhone">×</a>
        </div>
      </div>
    `;
  }

  getLabel(field) {
    const fieldMap = {
      number: 'number',
      phone_type: 'phone-type',
      use_case: 'use-case'
    };

    const dataKey = `companyModalLabel${fieldMap[field].split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('')}`;
    return this.element.dataset[dataKey] || field;
  }

  getPhoneTypeOptions() {
    return `
      <option value="mobile">Mobil</option>
      <option value="landline">Pevná linka</option>
      <option value="fax">Fax</option>
      <option value="other">Jiné</option>
    `;
  }

  getUseCaseOptions() {
    return `
      <option value="info">Info</option>
      <option value="technical">Technické</option>
      <option value="monitoring">Monitoring</option>
      <option value="business">Obchodní</option>
      <option value="marketing">Marketing</option>
      <option value="personal">Osobní</option>
      <option value="administrative">Administrativní</option>
      <option value="logistics">Logistika</option>
      <option value="emergency">Nouzové</option>
      <option value="other">Jiné</option>
    `;
  }
}
